class ReportSummaryController {
  constructor() {
    "ngInject";

    this.summaryMatrix = [];

    this.$onChanges = (changesObj) => {      
      this.summaryMatrix = this.listToMatrix(this.summary, 3);
    }   
  }

  listToMatrix(list, elementsPerSubArray) {
    if (!list){return;}
    
    var matrix = [], i, k;

    for (i = 0, k = -1; i < list.length; i++) {
        if (i % elementsPerSubArray === 0) {
            k++;
            matrix[k] = [];
        }

        matrix[k].push(list[i]);
    }

    return matrix;
  }
}

export default ReportSummaryController;



// WEBPACK FOOTER //
// ./client/app/components/reports/reportSummary/reportSummary.controller.js